"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, PhoneCall, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CallToAction() {
  const prefersReducedMotion = useReducedMotion();
  const benefits = ["Apoio técnico especializado", "Estudo dimensional à medida", "Resposta rápida e sem compromisso"];
  return <section id="calltoaction" data-nav="light" className="relative overflow-hidden bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={prefersReducedMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="relative mx-auto max-w-5xl rounded-3xl bg-primary px-6 py-12 text-primary-foreground shadow-2xl sm:px-12 sm:py-16 md:px-16">
          {/* Subtle background decoration */}
          <div aria-hidden="true" className="pointer-events-none absolute -right-20 -top-20 size-80 rounded-full bg-secondary/20 blur-3xl" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-20 -left-20 size-80 rounded-full bg-chart-1/40 blur-3xl" />

          <div className="relative z-10 grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
            <div className="space-y-6 lg:col-span-7">
              <div className="inline-flex items-center gap-2 rounded-full bg-primary-foreground/10 px-3.5 py-1 text-xs font-medium text-primary-foreground/90 backdrop-blur-xs">
                <span className="size-2 rounded-full bg-secondary" />
                <span>Spraying Systems Co. em Portugal</span>
              </div>

              <h2 className="font-default text-3xl font-bold tracking-tight text-primary-foreground sm:text-4xl">
                Encontre a solução ideal para o seu processo industrial
              </h2>

              <p className="max-w-xl text-base text-primary-foreground/80 sm:text-lg">
                Fale com a nossa equipa técnica de engenharia e otimize o rendimento, precisão e consumo dos seus sistemas de pulverização.
              </p>

              <ul className="grid grid-cols-1 gap-2.5 pt-2 sm:grid-cols-2">
                {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-center gap-2 text-sm text-primary-foreground/90">
                    <CheckCircle2 className="size-4 shrink-0 text-secondary" />
                    <span>{benefit}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-start gap-4 sm:flex-row lg:col-span-5 lg:flex-col lg:items-end">
              <Button asChild size="lg" className="w-full bg-secondary text-secondary-foreground shadow-md transition-[background-color,box-shadow] hover:bg-secondary/90 sm:w-auto lg:w-full">
                <Link to="/ContactsPage" className="inline-flex items-center justify-center gap-2">
                  <span>Solicite um orçamento</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full border-primary-foreground/20 bg-primary-foreground/5 text-primary-foreground shadow-xs transition-[background-color,border-color] hover:bg-primary-foreground/15 hover:text-primary-foreground sm:w-auto lg:w-full">
                <Link to="/ContactsPage" className="inline-flex items-center justify-center gap-2">
                  <PhoneCall className="size-4" />
                  <span>Falar com especialista</span>
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}